import React from 'react';
import { Spinner } from '../../components/ui';
import { fmtDate, fmtTime } from '../../utils/helpers';

export default function HeadcountMobile({ vm }) {
  const { loading, perFunction, grand, isTwoSided } = vm;
  return (
    <div>
      <div className="page-head"><h1>Headcount</h1></div>
      <div className="muted" style={{ marginBottom: 12, fontSize: 13 }}>
        Expected persons per function, deduped by mobile.
      </div>
      {loading ? <div className="card card-pad"><Spinner /></div>
        : perFunction.length === 0 ? <div className="card card-pad empty">No functions yet.</div> : (
          <div className="mobile-card-list">
            {perFunction.map(({ fn, parties, persons, extra, bySide }) => (
              <div key={fn.FunctionId} className="card card-pad mobile-record-card row-link" onClick={() => vm.openRow(fn)}>
                <div className="mobile-card-head" style={{ alignItems: 'baseline' }}>
                  <strong className="mobile-title">{fn.FunctionName}</strong>
                  <div style={{ flex: 1 }} />
                  <span style={{ fontSize: 28, fontWeight: 800 }}>{persons}</span>{extra > 0 && <span className="muted" style={{ fontSize: 11 }}> incl. {extra} extra-card</span>}
                </div>
                <div className="mobile-meta">
                  <div className="muted">
                    {fmtDate(fn.FunctionDate)}{fn.FunctionTime ? ` | ${fmtTime(fn.FunctionTime)}` : ''} | {parties} parties
                  </div>
                  {isTwoSided && <div>Groom {bySide.Groom} | Bride {bySide.Bride} | Common {bySide.Common}</div>}
                </div>
              </div>
            ))}
            <div className="card card-pad mobile-record-card">
              <div className="mobile-card-head" style={{ alignItems: 'baseline' }}>
                <strong className="mobile-title">All functions</strong>
                <div style={{ flex: 1 }} />
                <span style={{ fontSize: 22, fontWeight: 800 }}>{grand.persons}</span>
              </div>
              <div className="muted" style={{ fontSize: 12 }}>person-visits</div>
            </div>
          </div>
        )}
    </div>
  );
}
